export default __webpack_public_path__ + "static/media/faction-coa.654bc0fc.png";